import React, { Component } from 'react';
import styled from 'styled-components';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import QuoteItem from './Item';
import { grid, colors } from './constants';
import Title from './Title';
import type {
  DroppableProvided,
  DroppableStateSnapshot,
  DraggableProvided,
  DraggableStateSnapshot,
} from 'react-beautiful-dnd';
import hasAccess from "../../helpers/permissionChecker";

const Wrapper = styled.div`
  background-color: ${({ isDraggingOver }) => (isDraggingOver ? colors.blue.lighter : colors.blue.light)};
  display: flex;
  flex-direction: column;
  opacity: ${({ isDropDisabled }) => (isDropDisabled ? 0.5 : 'inherit')};
  padding: ${grid}px;
  padding-bottom: 0;
  transition: background-color 0.1s ease, opacity 0.1s ease;
  user-select: none;
`;

const DropZone = styled.div`
  /* stop the list collapsing when empty */
  min-height: 250px;
  /* not relying on the items for a margin-bottom
  as it will collapse when the list is empty */
  margin-bottom: ${grid}px;
`;

const ScrollContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 1000px;
`;

const Container = styled.div``;

export default class QuoteList extends Component {

  componentDidMount() {
    setTimeout(function() {
      const arrEl = document.querySelectorAll('.column-title');
      let max = 0;

      for (let i = 0; i < arrEl.length; i++) {
        if (arrEl[i].parentNode.parentNode.parentNode.clientHeight > max) {
          max = arrEl[i].parentNode.parentNode.parentNode.clientHeight;
        }
      }

      for (let i = 0; i < arrEl.length; i++) {
        arrEl[i].parentNode.parentNode.parentNode.style.height = max + 'px';
        arrEl[i].parentNode.parentNode.parentNode.querySelectorAll('div')[1].querySelector('div').querySelector('div').style.height = max + 'px';
      }
    }, 1000);
  }

  renderQuotes = (dropProvided) => {
    const {
      listType,
      quotes
    } = this.props;
    const title = this.props.title ? (
      <Title>{this.props.title}</Title>
    ) : null;

    if (!quotes) {
      return null;
    }

    return (
      <Container>
        {title}
        <DropZone innerRef={dropProvided.innerRef}>
          {quotes.map((quote) => {
            return (
              <Draggable key={'quote-draggable-' + quote.id + '' + quote.task_id} draggableId={quote.task_id}
                         type={listType}
                         isDragDisabled={
                           !hasAccess({
                             'permAreaKey': 'workOrder',
                             'permTypeKey': 'move',
                             'idForCheckingAuthor': quote.sp_user_id
                           }) ||
                           !hasAccess({
                             'permAreaKey': 'workOrder',
                             'permTypeKey': 'move',
                             'idForCheckingAuthor': quote.user_id
                           })
                         }>
                {(dragProvided, dragSnapshot) => (
                  <div>
                    <QuoteItem
                      extraFieldToShow={this.props.extraFieldToShow}
                      lanesList={this.props.lanesList}
                      key={'quote-item-' + quote.id}
                      quote={quote}
                      isDragging={dragSnapshot.isDragging}
                      provided={dragProvided}
                      autoFocus={this.props.autoFocusQuoteId === quote.id}
                      handlerOpenTask={this.props.handlerOpenTask}
                      handlerOpenPreView={this.props.handlerOpenPreView}
                      isFullScreen={this.props.isFullScreen}
                    />
                    {dragProvided.placeholder}
                  </div>
                )}
              </Draggable>
            )
          })
          }
          {dropProvided.placeholder}
        </DropZone>
      </Container>
    );
  }

  render() {
    const {
      ignoreContainerClipping,
      internalScroll,
      isDropDisabled,
      listId,
      listType,
      style,
    } = this.props;

    let customStyle = style || {};

    if (this.props.isFullScreen) {
      //customStyle.width = '165px';
    } else {
      delete customStyle.width;
    }

    return (
      <Droppable
        droppableId={listId}
        ignoreContainerClipping={ignoreContainerClipping}
        isDropDisabled={isDropDisabled}
        type={listType}
      >
        {(dropProvided: DroppableProvided, dropSnapshot: DroppableStateSnapshot) => (
          <Wrapper
            style={customStyle}
            isDraggingOver={dropSnapshot.isDraggingOver}
            isDropDisabled={isDropDisabled}
          >
            {internalScroll ? (
              <ScrollContainer>
                {this.renderQuotes(dropProvided)}
              </ScrollContainer>
            ) : (
              this.renderQuotes(dropProvided)
            )}
          </Wrapper>
        )}
      </Droppable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/ItemList.js